// React
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Skeleton from 'ui/blocks/Skeleton'

// Shared
import withStore from 'shop-components/utils/withStore'
import withTheme from 'shop-components/utils/withTheme'
import { withTranslation } from 'shared/utils/withTranslation'
import registerCustomElement from 'shop-components/utils/registerCustomElement'
import { fetchPrice, fetchPrices } from 'shop-components/redux/actions/price'

const ProductPriceLabel = ({
  productId,
  label,
  isLoading,
  defaultLabel,
  cart,
  product,
  fetchProductPrices,
  fetchProductPrice
}) => {
  useEffect(() => {
    if (product?.id && cart?.id && (product?.variation_id || product?.configuration)) {
      return fetchProductPrice({
        cartId: cart.id,
        id: product.variation_id || product.id,
        configuration: product.configuration
      })
    }

    if (productId && cart?.id) {
      fetchProductPrices({
        cartId: cart.id,
        id: productId
      })
    }
  }, [productId, product?.id, product?.variation_id, product?.configuration, cart.id, cart.startsAt, cart.stopsAt])

  if (isLoading) return <Skeleton width={150} />

  if (label) return label

  if (defaultLabel) return defaultLabel

  return null
}

ProductPriceLabel.displayName = 'ProductPriceLabel'

ProductPriceLabel.propTypes = {
  productId: PropTypes.string,
  label: PropTypes.any,
  isLoading: PropTypes.bool,
  defaultLabel: PropTypes.any,
  cart: PropTypes.object,
  product: PropTypes.object,
  fetchProductPrices: PropTypes.func,
  fetchProductPrice: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId || window.booqableOptions.cart?.id)
  const product = state.items.records[props.productId]
  const type = product?.price?.product_type
  const label = ['consumable', 'sales_item'].includes(type) ? props.t('user.store.buy') : product?.price?.charge_label

  return {
    cart: {
      id: cart?.id ?? window.booqableOptions.cart?.id,
      startsAt: cart?.starts_at ?? window.booqableOptions.cart?.from,
      stopsAt: cart?.stops_at ?? window.booqableOptions.cart?.till
    },
    isLoading: state.items.loading && !label,
    label,
    product
  }
}

const mapDispatchToProps = (dispatch, _props) => ({
  fetchProductPrice: (attributes) => dispatch(fetchPrice(attributes)),
  fetchProductPrices: (attributes) => dispatch(fetchPrices(attributes))
})

const decoratedComponent = compose(
  withStore,
  withTranslation('user'),
  withTheme,
  reduxConnect(mapStateToProps, mapDispatchToProps)
)(ProductPriceLabel)

registerCustomElement('bq-product-price-label', decoratedComponent, {
  mountElement: 'span',
  attributes: ['product-id', 'default-label']
})

export default decoratedComponent
